import { h } from 'preact'
import IdeationListItem from './IdeationListItem'
import { IdeaStatus } from './Types'
import Table from '../table/Table'

interface Props {
  deleteCallback: (idx: number) => void,
  openEditIdeationModal: (item: IdeaStatus, idx: number) => void,
  list: Array<IdeaStatus>,
  colors: Array<string>
}

const IdeationList = ({ list, colors, deleteCallback, openEditIdeationModal }: Props) => {
  const model = [
    {
      header: 'Status',
      accessor: 'status'
    },
    {
      header: 'Background Color',
      accessor: 'bgColor'
    },
    {
      header: 'Text Color',
      accessor: 'textColor'
    },
    {
      header: 'Actions',
      accessor: 'actions'
    }]

  const rows = list.map((item, idx) => IdeationListItem({ item, deleteCallback, openEditIdeationModal, idx, colors }))

  return (
    <Table model={model} rows={rows} borderless nonStripe borderRadius='4px' />
  )
}

export default IdeationList
